import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiShield } from 'react-icons/fi';
import { auth, db } from '../../firebase/firebase';
import { GoogleAuthProvider, signInWithPopup, signOut } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import PortalLoginShell from '../../components/shared/PortalLoginShell';

const SuperAdminLogin = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleGoogleSignIn = async () => {
    setLoading(true);
    setError('');

    const provider = new GoogleAuthProvider();
    provider.setCustomParameters({ prompt: 'select_account' });

    try {
      const result = await signInWithPopup(auth, provider);
      const email = (result.user.email || '').toLowerCase();

      if (!email) {
        await signOut(auth);
        setError('Could not read email from Google account.');
        return;
      }

      const adminSnap = await getDoc(doc(db, 'superAdmins', email));
      if (!adminSnap.exists()) {
        await signOut(auth);
        setError(`${email} is not authorized for super admin access.`);
        return;
      }

      localStorage.setItem('superAdminAuth', 'true');
      localStorage.setItem('adminUser', email);
      navigate('/admin');
    } catch (err) {
      if (err.code === 'auth/popup-closed-by-user' || err.code === 'auth/cancelled-popup-request') {
        setError('');
      } else {
        console.error('Super admin sign-in error:', err);
        setError(err.message || 'Sign-in failed. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <PortalLoginShell
      portalLabel="Super Admin"
      title="Manage every company, vendor, and employee on Loysta."
      description="The platform admin portal — onboard companies, whitelist vendors, and keep an eye on the whole network from one dashboard."
      accent="#3b82f6"
      Icon={FiShield}
      onGoogleSignIn={handleGoogleSignIn}
      loading={loading}
      error={error}
      footerHint="Authorized personnel only. Access is restricted to whitelisted Google accounts."
      otherPortals={[
        { to: '/company/login', label: 'Company login' },
        { to: '/vendor/login', label: 'Vendor login' },
      ]}
    />
  );
};

export default SuperAdminLogin;
